import { DOCUMENT_NUMBER_EXPRESSION } from '../../constants';

const validateDocuments = (fieldToValidate, type) => {
  const isFieldValid = (field) => field !== undefined && field !== null && field !== '';
  switch (type) {
    case 'documentNumber':
      return isFieldValid(fieldToValidate)
        && new RegExp(DOCUMENT_NUMBER_EXPRESSION).test(fieldToValidate);
    case 'issuingCountryCode':
    case 'nationalityCountryCode':
    case 'expirationDate':
    case 'travelToCountryCode':
    case 'countryCode':
      return isFieldValid(fieldToValidate);
    default:
      return false;
  }
};

export default validateDocuments;
